// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tools-popover[data-v-5d02345a]{margin-right:32px;width:20px;height:20px}.tools-popover-icon[data-v-5d02345a]{cursor:pointer;position:relative;fill:#d9dcdf}.tools-popover-icon[data-v-5d02345a]:hover:before{content:\"\";position:absolute;width:60px;height:20px;top:15px;left:-20px}", ""]);
// Exports
module.exports = exports;
